// extracted by mini-css-extract-plugin
module.exports = {"container":"Phone_container__3allz","icon":"Phone_icon__2fXp1","cell":"Phone_cell__2nPsE","number":"Phone_number__17hin"};